import { User } from '@lfx/core/models';

export interface SearchUserResult {
  searchUser: User[];
}
